import flashCardsSvg from '../../../../../assets/images/ornament-wrapper/flash-cards.raw.svg';
import * as styles from '../OrnamentWrapper.styles';

export const FlashCards = () => {
  return <div css={styles.flashCardsSvg(flashCardsSvg)} />;
};
